// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BJWD","title":"Header_title__1UjCV","left":"Header_left__6npru","clinicName":"Header_clinicName__3LdAv"};